import React from "react";
import Icon from "../Icon";
import PropTypes from "prop-types";

export default function Button(props) {
  let { type, label, suffixIcon, ...args } = props;
  let iconColors = {
    primary: "#FFFFFF",
    secondary: "#253858",
    destructive: "#FFFFFF",
    transparent: "#253858",
    danger: "#db2424",
  };
  return (
    <button
      className={`
      km__c--button
      ${!label ? "km__c--button-is-icon" : ""} km__c--button-is-${type}
      km__c--button-icon-is-${suffixIcon}
      `}
      {...args}
    >
      {label}
      {suffixIcon ? (
        <Icon
          name={suffixIcon}
          size="15"
          color={!label ? "#00a3bf" : iconColors[type]}
        />
      ) : null}
    </button>
  );
}

Button.propTypes = {
  label: PropTypes.string,
  type: PropTypes.oneOf([
    "primary",
    "secondary",
    "destructive",
    "transparent",
    "danger",
  ]),
  suffixIcon: PropTypes.oneOf([
    "alert-circle",
    "alert-octagon",
    "alert-triangle",
    "bell",
    "check",
    "chevron-down",
    "chevron-up",
    "chevron-right",
    "chevron-left",
    "download",
    "minimize-2",
    "minimize",
    "minus",
    "plus",
    "refresh-ccw",
    "search",
    "edit",
    "x",
  ]),
};
Button.defaultProps = {
  type: "primary",
};
